import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import * as Para from 'vendys/translations/paragraph';

export function deepMerge() {
  for (var o = {}, i = 0; i < arguments.length; i++) {
    // if (arguments[i].constructor !== Object) continue;
    for (let k in arguments[i]) {
      // eslint-disable-next-line no-prototype-builtins
      if (arguments[i].hasOwnProperty(k)) {
        if (!arguments[i][k]) {
          o[k] = arguments[i][k];
        } else {
          o[k] = arguments[i][k].constructor === Object ? deepMerge(o[k] || {}, arguments[i][k]) : arguments[i][k];
        }
      }
    }
  }
  return o;
}

let empty = ' ';

export function FormattedMessageDynamic(props: any = {}) {
  let params = {
    ...props,
    id: props.id || empty,
    defaultMessage: props.defaultMessage || props.id || empty
  };

  return <FormattedMessage {...params} />;
}

export function FormattedMessageFixed(props) {
  if (!props.id || props.id.replace(/\s/gi, '').length == 0) return;
  return <FormattedMessage {...props} />;
}

export function FM(props) {
  return (
    <FormattedMessage {...props}>
      {(msg) => {
        if (!msg || msg.length < 1) return '';
        return msg[0].split('\n').map((r, i) => (
          <span key={`p-${i}`}>
            {r}
            <br />
          </span>
        ));
      }}
    </FormattedMessage>
  );
}

export function Paragraph(props) {
  return (
    <FM values={{ newline: '<br />' }} {...props}>
      {toParagraphs}
    </FM>
  );
}
export function ParagraphHTML(props) {
  return <div dangerouslySetInnerHTML={{ __html: Para[props.id] }}></div>;
}

const toParagraphs = (...nodes) => {
  let key = 0;
  const children = nodes.reduce(
    (result, node) =>
      result.concat(
        typeof node === 'string' ? node.split('\n').map((paragraph) => <p key={++key}>{paragraph}</p>) : node
      ),
    []
  );

  return <span>{children}</span>;
};

export function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export const obj = {
  changeKey: (data = {}, oc = {}) => {
    for (var oldKey in oc) {
      var newKey = oc[oldKey];
      data[newKey] = data[oldKey];
      delete data[oldKey];
    }
    return data;
  },
  recursiveFn: (data = {}, childrenKey = 'children', fn = (row) => {}) => {
    var f = (data) => {
      fn(data);
      if (data[childrenKey]) {
        data[childrenKey].map((child) => {
          f(child);
        });
      }
    };

    f(data);
  },
  recursive: (data = {}, childrenKey = 'children', keys = []) => {
    var obj = {};
    keys.map((key) => (obj[key] = []));

    var f = (data) => {
      keys.map((key) => {
        data[key] && obj[key].push(data[key]);
      });
      if (data[childrenKey]) {
        data[childrenKey].map((child) => {
          f(child);
        });
      }
    };

    f(data);
    return obj;
  },
  get: (data, str) => {
    return str.split('.').reduce((o, i) => o[i], data);
  }
};

export const arr = {
  merge: (data, { key, values = [] }) => {
    if (values.constructor === String) values = [values];

    var obj = {};

    data.forEach((row) => {
      var id = row[key];
      if (!obj[id]) {
        obj[id] = { _data: [] };
        Object.keys(row).forEach((kkk) => (obj[id][kkk] = row[kkk]));
      }
      obj[id]._data.push(row);
    });
    for (var k in obj) {
      var { _data } = obj[k];
      values.forEach((value) => {
        obj[k][value] = 0;
      });

      _data.forEach((row) => {
        values.forEach((value) => {
          var v = row[value];
          if (!v) return;
          if (v.constructor != Number) {
            v = parseInt(v.replace(/\,/gi, ''));
          }
          obj[k][value] += v;
        });
      });
    }
    return Object.values(obj);
  },
  keyc: (data, keys, del = true) => {
    data.map((row) => {
      Object.keys(keys).map((key) => {
        var v = keys[key];
        row[v] = row[key];
        del && delete row[key];
      });
    });
  },
  group: (data, { key }) => {
    var obj = {};

    data.forEach((row) => {
      var id = row[key];
      if (!obj[id]) {
        obj[id] = [];
      }
      obj[id].push(row);
    });
    return obj;
  },
  clone: (data, binding = {}) => {
    return data.map((row) => {
      var obj = {};
      Object.keys(binding).map((key) => {
        obj[binding[key]] = cloneObject(row[key]);
      });
      return obj;
    });
  }
};

function cloneObject(obj) {
  var clone = {};
  if (obj.constructor !== Object) return obj;
  for (var key in obj) {
    if (obj[key].constructor === Array) {
      clone[key] = [].concat(obj[key]);
    } else if (typeof obj[key] == 'object' && obj[key] != null) {
      clone[key] = cloneObject(obj[key]);
    } else {
      clone[key] = obj[key];
    }
  }

  return clone;
}

export const clone = (data, isDeep = false) => {
  if (isDeep) {
    return cloneObject(data);
  } else {
    return { ...data };
  }
};

export const transMeta = (data) => {
  return data.map((row) => {
    const { HeaderId: label, viewId: type, accessor: id, name, ...rest } = row;
    return { label, type, id, name: name || id, ...rest };
  });
};

export const delay = (time = 100) => {
  return new Promise((resolve) =>
    setTimeout(() => {
      resolve();
    }, time)
  );
};

export const generateHash = async (memberId, secretKey) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(memberId);

  const key = await window.crypto.subtle.importKey(
    'raw',
    new TextEncoder().encode(secretKey),
    { name: 'HMAC', hash: { name: 'SHA-256' } },
    false,
    ['sign']
  );

  const hashBuffer = await window.crypto.subtle.sign('HMAC', key, data);

  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map((byte) => byte.toString(16).padStart(2, '0')).join('');

  return hashHex;
};

import * as chart from './chart';
export { chart };
